import { Route } from '@angular/router';
import { BaseAppComponent } from './core/layouts/base-app/base-app.component';
import { authGuard } from '@mglsk/ng-auth';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    canActivate: [authGuard],
    component: BaseAppComponent,
    children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'jobs',
        loadChildren: () => import('./features/jobs/jobs.routes').then((m) => m.jobsRoutes),
      },
      {
        path: 'companies',
        loadChildren: () => import('./features/companies/companies.routes').then((m) => m.companiesRoutes),
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () => import('./features/errors/error.routes').then((m) => m.errorRoutes),
  },
];
